export const HOME_CONTENT = Object.freeze({
  it: {
    seo: {
      title: 'BullVerge | Ecosistema edge AI locale, umano e modulare',
      description:
        'BullVerge costruisce dispositivi, moduli e governance edge AI per portare intelligenza locale, privacy e autonomia in prodotti reali come Prometeo, Nemo, BackSense e Aura.',
      imageAlt: 'Ecosistema BullVerge, dispositivi e moduli edge AI locali'
    },
    hero: {
      badge: 'Ecosistema AI locale',
      title: 'AI locale, utile, più vicina alle persone',
      accent: 'più vicina',
      copy:
        'In BullVerge vogliamo costruire un mondo in cui ogni dispositivo sia intelligente, vogliamo dare intelligenza e abilità reali ad ogni macchina',
      primary: 'Esplora l’ecosistema',
      secondary: 'Leggi i paper',
      note: 'Locale · Basso Consumo · Orientato alla Privacy · Costruito per Contesti Reali'
    },
    mission: {
      eyebrow: 'Missione',
      title: 'Rendere l’AI indipendente dalle connessioni',
      copy:
        'La nostra direzione è portare capacità intelligenti vicino a hardware, dati e utenti: meno latenza, più controllo, migliore continuità operativa e una relazione più umana con la tecnologia.',
      points: [
        'AI su dispositivo dove privacy, resilienza o connettività lo richiedono',
        'Moduli componibili per voce, visione, conoscenza, controllo senza contatto e routing degli intenti umani',
        'Prodotti verticali per diversi settori: dalla vita quotidiana alla sicurezza personale, dall\'assistenza sanitaria alla prevenzione in difesa'
      ]
    },
    ecosystem: {
      eyebrow: 'Ecosistema',
      title: 'Prodotti, moduli, gestione intelligente e ricerca compongono la piattaforma',
      copy:
        'Distinguiamo linee prodotto e moduli: Prometeo, Nemo, BackSense e Aura sono prodotti; Core, Voce, Visione, Conoscenza, Horizon, PSIC e le Pipeline ibride sono capacità componibili; Aegis è il metodo che le coordina.',
      productsCta: 'Vedi prodotti',
      modulesCta: 'Vedi moduli'
    },
    aegis: {
      eyebrow: 'Aegis',
      title: 'Il metodo di gestione che tiene insieme l’ecosistema',
      copy:
        'Aegis non è l’ennesimo runtime e non è un prodotto separato da mostrare come una brochure: è la logica operativa che governa carichi locali, risorse hardware, moduli e flussi ibridi.',
      points: [
        'Decide cosa e come instradare, gestisce le risorse e coordina l\'intero sistema',
        'Coordina risorse limitate su dispositivi edge',
        'Rende coerenti prodotti diversi senza duplicare architetture'
      ],
      cta: 'Scopri Aegis'
    },
    modulesPreview: {
      eyebrow: 'Moduli',
      title: 'Le capacità che danno forma ai prodotti',
      copy:
        'Core locale, Voce, Visione, Conoscenza, Horizon, PSIC e Pipeline ibrida sono leve tecniche che cambiano in base al contesto: Prometeo, Nemo, BackSense, Aura, kiosk, postazioni o hardware partner.'
    },
    impact: {
      eyebrow: 'Impatto',
      title: 'Dove vogliamo arrivare con BullVerge?',
      copy:
        'L’impatto non nasce da un singolo dispositivo, ma quando la stessa base tecnologica diventa utile in cura quotidiana, sicurezza personale, formazione, industria, difesa e comunità con meno accesso a infrastrutture costose.'
    },
    strategic: {
      eyebrow: 'R&D verticale',
      title: 'Nuovi prodotti in sviluppo per difesa e sanità',
      copy:
        'Stiamo studiando estensioni dell’ecosistema per contesti militari e sanitari, con attenzione a continuità operativa, sovranità del dato, flussi assistivi e integrazione su hardware robusto o orientato alla privacy.',
      items: [
        {
          title: 'Difesa / settore militare',
          copy:
            'Linee R&D per supporto operativo, conoscenza locale, analisi documentale e assistenza decisionale in scenari a bassa connettività o critici per la missione.'
        },
        {
          title: 'Sanità',
          copy:
            'Prodotti orientati a promemoria, documentazione, consultazione locale di conoscenza sensibile e flussi assistivi integrabili nei processi sanitari.'
        }
      ],
      note:
        'Queste verticali sono in sviluppo: comunicheremo dettagli tecnici e disponibilità solo dopo validazioni, partnership e perimetri regolatori chiari.'
    },
    validation: {
      eyebrow: 'Validazione',
      title: 'Traiettoria tecnica',
      copy:
        'Stiamo mettendo insieme evidenze, ricerca pubblica, architettura modulare e partnership per rendere chiara la direzione ai primi utilizzatori, partner tecnici e interlocutori industriali.',
      items: [
        'Presenza su AWS Startup Showcase',
        'Paper tecnici e PSIC disponibili in Academy',
        'Architettura modulare leggibile nell’Ecosistema',
        'FAQ dedicate per prodotto, privacy, tecnologia e partner'
      ]
    },
    faqCta: {
      title: 'Hai bisogno di una risposta rapida?',
      copy:
        'Prodotti, moduli, Aegis, privacy, collaborazioni e preordine sono spiegati nel dettaglio.',
      cta: 'Apri le FAQ'
    },
    partner: {
      eyebrow: 'AWS Showcase',
      title: 'AWS Startup Showcase',
      copy: 'Siamo presenti nello Startup Showcase AWS.',
      link: 'Vedi la vetrina AWS'
    }
  },
  en: {
    seo: {
      title: 'BullVerge | Local, human and modular edge AI ecosystem',
      description:
        'BullVerge builds edge AI devices, modules and AI-aware governance technologies to bring local intelligence, privacy and autonomy into real products such as Prometeo, Nemo, BackSense and Aura.',
      imageAlt: 'BullVerge ecosystem, local edge AI devices and modules'
    },
    hero: {
      badge: 'Local AI ecosystem',
      title: 'Local, useful AI closer to people',
      accent: 'closer',
      copy:
        'At BullVerge, we want to build a world where every device can become intelligent. We give real intelligence and practical abilities to machines.',
      primary: 'Explore the ecosystem',
      secondary: 'Read the papers',
      note: 'Local-first · low-power · privacy-oriented · built for real contexts'
    },
    mission: {
      eyebrow: 'Mission',
      title: 'Make AI independent from constant connectivity',
      copy:
        'Our direction is to bring intelligent capabilities closer to hardware, data and users: lower latency, more control, better operational continuity and a more human relationship with technology.',
      points: [
        'On-device AI where privacy, resilience or connectivity require it',
        'Composable modules for voice, vision, knowledge, touchless interaction and intent routing',
        'Vertical products for daily life, personal safety, healthcare assistance and defense prevention'
      ]
    },
    ecosystem: {
      eyebrow: 'Ecosystem',
      title: 'Products, modules, intelligent management and research form the platform',
      copy:
        'At BullVerge, we separate product lines from modules: Prometeo, Nemo, BackSense and Aura are products; Core, Voice, Vision, Knowledge, Horizon, PSIC and Hybrid Pipeline are composable capabilities; Aegis is the method that coordinates them.',
      productsCta: 'View products',
      modulesCta: 'View modules'
    },
    aegis: {
      eyebrow: 'Aegis',
      title: 'The management method that keeps the ecosystem together',
      copy:
        'Aegis is not another runtime: it is the operating logic that governs local workloads, hardware resources, modules and hybrid flows across the ecosystem.',
      points: [
        'Decides what and how to route, manages resources and coordinates the whole system',
        'Coordinates constrained resources on edge devices',
        'Keeps different products coherent through a shared architecture'
      ],
      cta: 'Discover Aegis'
    },
    modulesPreview: {
      eyebrow: 'Modules',
      title: 'The capabilities that shape the products',
      copy:
        'Local Core, Voice, Vision, Knowledge, Horizon, PSIC and Hybrid Pipeline are technical levers that change with the context: Prometeo, Nemo, BackSense, Aura, kiosks, workstations or partner hardware.'
    },
    impact: {
      eyebrow: 'Impact',
      title: 'Where we want to take BullVerge',
      copy:
        'Impact emerges when the same technology foundation becomes useful across everyday care, personal safety, education, industry, defense and communities with limited access to expensive infrastructure.'
    },
    strategic: {
      eyebrow: 'Vertical R&D',
      title: 'New products in development for defense and healthcare.',
      copy:
        'We are developing ecosystem extensions for military and healthcare contexts, with attention to operational continuity, data sovereignty, assistive workflows and integration on rugged or privacy-oriented hardware.',
      items: [
        {
          title: 'Defense / military sector',
          copy:
            'R&D lines for operational support, local knowledge, document analysis and decision assistance in low-connectivity or mission-critical scenarios.'
        },
        {
          title: 'Healthcare',
          copy:
            'Products oriented around reminders, documentation, local consultation of sensitive knowledge and assistive workflows for healthcare environments.'
        }
      ],
      note:
        'These verticals are in development: technical details and availability will be communicated only after requirements, partnerships and regulatory boundaries are clear.'
    },
    validation: {
      eyebrow: 'Validation',
      title: 'A technical direction that can be evaluated.',
      copy:
        'We are combining evidence, public research, modular architecture and partnerships to make the direction clear for early adopters, technical partners and industrial stakeholders.',
      items: [
        'Presence on AWS Startup Showcase',
        'Technical papers and PSIC available in Academy',
        'Modular architecture explained in Ecosystem',
        'Dedicated FAQ for products, privacy, technology and partners'
      ]
    },
    faqCta: {
      title: 'Need a fast answer?',
      copy:
        'Products, modules, Aegis, privacy, collaborations and preorder are explained in direct answers.',
      cta: 'Open FAQ'
    },
    partner: {
      eyebrow: 'AWS Showcase',
      title: 'AWS Startup Showcase',
      copy: 'We are listed in the AWS Startup Showcase.',
      link: 'View AWS showcase'
    }
  }
})

export function getHomeContent(locale) {
  return HOME_CONTENT[locale] || HOME_CONTENT.it
}
